/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { ListeTable } from '@mairistem/liste';

import { Input } from '@mairistem/composants';

import type { Specialite } from '@/types';
import type { ListeTableRowProps } from '@mairistem/liste/lib/ts/src/components/ListeTable/ListeTableRow';

interface Props {
  /** Spécialité */
  specialite?: Specialite;
  /** Props de la ligne */
  rowProps?: ListeTableRowProps<Specialite>;
  /** Utilitaires de la ligne */
  utilities?: {
    onChange: (objet: object) => void;
    autoFocus?: { value: boolean };
    disableFocus?: { value: boolean };
    disableShiftTabulation?: { value: boolean };
    disableDrag?: { value: boolean };
  };
  /** Erreurs */
  errors?: { error: string }[];
  /** Callback appelé lors d'un double clic sur la ligne */
  onDoubleClick?: (specialite: Specialite) => void;
}

const SpecialiteListeTableRow = (props: Props) => {
  const {
    specialite: { identifiant, libelle, code } = {},
    rowProps = {},
    utilities = null,
    errors = [],
    onDoubleClick = null,
  } = props;

  const handleRowChange = React.useCallback(
    (
      _e: React.FormEvent<HTMLInputElement>,
      data: { name: string; value: unknown },
    ) => {
      const { name, value } = data;
      utilities?.onChange({ [name]: value });
    },
    [utilities],
  );

  const handleDoubleClick = React.useCallback(() => {
    if (onDoubleClick) {
      onDoubleClick({ identifiant, libelle, code });
    }
  }, [onDoubleClick, identifiant, libelle, code]);

  return (
    <ListeTable.Row
      key={identifiant}
      error={_.some(errors, { itemId: identifiant })}
      {...rowProps}
    >
      <ListeTable.Cell
        name="code"
        stretched
        // @ts-expect-error
        onDoubleClick={handleDoubleClick}
      >
        <Input
          error={_.some(errors, { itemId: identifiant, field: 'code' })}
          name="code"
          id={`code-${identifiant}`}
          value={code}
          onChange={handleRowChange}
          fluid
          transparent
          readOnly={rowProps.selection}
          {...utilities?.autoFocus}
          {...utilities?.disableShiftTabulation}
          {...utilities?.disableFocus}
          {...utilities?.disableDrag}
        />
      </ListeTable.Cell>
      <ListeTable.Cell
        name="libelle"
        stretched
        // @ts-expect-error
        onDoubleClick={handleDoubleClick}
      >
        <Input
          error={_.some(errors, { itemId: identifiant, field: 'libelle' })}
          name="libelle"
          id={`libelle-${identifiant}`}
          value={libelle}
          onChange={handleRowChange}
          fluid
          transparent
          readOnly={rowProps.selection}
          {...utilities?.disableFocus}
          {...utilities?.disableDrag}
        />
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default SpecialiteListeTableRow;
